import { useCallback } from 'react';
import { useSuccessReactor } from '@livefree/reactive';
import { useNavigate } from 'react-router';
import { useLoginInfo } from '@/features/login';
import { RoutePaths } from '@/routing/RoutePaths';

export const useLogin = (services, dispatch) => {
  const info = useLoginInfo();
  const navigate = useNavigate();

  useSuccessReactor(services.login.login, payload => {
    if (payload.isSuccessful) {
      if (payload.twoFactorRequired) {
        dispatch({
          type: 'twofactor',
          payload: {
            validationToken: payload.twoFactorValidationToken,
            userId: payload.user.id,
          },
        });
      } else if (payload.requiresPasswordReset) {
        navigate(RoutePaths().login.resetRequired());
      } else {
        window.location = payload.redirectUrl;
      }
    } else {
      dispatch({
        type: 'message',
        payload: 'Unable to log you in. Check username and password and try again.',
      });
    }
  });

  useSuccessReactor(services.login.twoFactorLogin, payload => {
    if (payload.isSuccessful) {
      window.location = payload.redirectUrl;
    } else {
      dispatch({
        type: 'message',
        payload: payload.message,
      });
    }
  });

  const handleLogin = useCallback(
    (username, password) => {
      services.login.login(username, password, info.returnUrl);
    },
    [services, info.returnUrl],
  );

  const handleTwoFactorLogin = useCallback(
    (twoFactorType, userId, validationToken, token) => {
      services.login.twoFactorLogin(twoFactorType, userId, validationToken, token, info.returnUrl);
    },
    [services, info.returnUrl],
  );

  return {
    login: handleLogin,
    twoFactorLogin: handleTwoFactorLogin,
  };
};
